/* tslint:disable */
/* eslint-disable */
/**
 * Clients API
 * API des listes de clients (personnes ayant au moins un contrat)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetAdminClientListResponse,
  GetClientListResponse,
  GetFacetsResponse,
  GetGenericListCommandDto,
} from '../models/index';
import {
    GetAdminClientListResponseFromJSON,
    GetAdminClientListResponseToJSON,
    GetClientListResponseFromJSON,
    GetClientListResponseToJSON,
    GetFacetsResponseFromJSON,
    GetFacetsResponseToJSON,
    GetGenericListCommandDtoFromJSON,
    GetGenericListCommandDtoToJSON,
} from '../models/index';

export interface GetAdminClientListFacetsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetAdminClientsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetClientListFacetsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetClientsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

/**
 * 
 */
export class ClientsApi extends runtime.BaseAPI {

    /**
     * Facettes de la liste admin des clients, avec les dimensions plateformes et courtiers en plus (personTypes, branches, plateformes, brokers). Permission BackOffice.AdminClients.Read (403 sinon). 
     * Facettes de la liste admin des clients (BO admin)
     */
    async getAdminClientListFacetsRaw(requestParameters: GetAdminClientListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFacetsResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getAdminClientListFacets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/clients/admin/liste/filtres`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFacetsResponseFromJSON(jsonValue));
    }

    /**
     * Facettes de la liste admin des clients, avec les dimensions plateformes et courtiers en plus (personTypes, branches, plateformes, brokers). Permission BackOffice.AdminClients.Read (403 sinon). 
     * Facettes de la liste admin des clients (BO admin)
     */
    async getAdminClientListFacets(requestParameters: GetAdminClientListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFacetsResponse> {
        const response = await this.getAdminClientListFacetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liste admin paginée des clients, toutes plateformes. Items enrichis du rattachement direct courtier / plateforme. filters.plateformeIds et filters.brokerIds disponibles. Permission BackOffice.AdminClients.Read (403 sinon). 
     * Lister les clients, toutes plateformes (BO admin)
     */
    async getAdminClientsRaw(requestParameters: GetAdminClientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAdminClientListResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getAdminClients().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/clients/admin/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAdminClientListResponseFromJSON(jsonValue));
    }

    /**
     * Liste admin paginée des clients, toutes plateformes. Items enrichis du rattachement direct courtier / plateforme. filters.plateformeIds et filters.brokerIds disponibles. Permission BackOffice.AdminClients.Read (403 sinon). 
     * Lister les clients, toutes plateformes (BO admin)
     */
    async getAdminClients(requestParameters: GetAdminClientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAdminClientListResponse> {
        const response = await this.getAdminClientsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Facettes du panneau de filtres de la liste des clients (personTypes, branches). Envoyer les filtres courants dans le body : options contextuelles, une dimension ne s\'auto-restreint pas. Permission BackOffice.Clients.Read. 
     * Facettes de la liste des clients (courtier)
     */
    async getClientListFacetsRaw(requestParameters: GetClientListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFacetsResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getClientListFacets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/clients/liste/filtres`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFacetsResponseFromJSON(jsonValue));
    }

    /**
     * Facettes du panneau de filtres de la liste des clients (personTypes, branches). Envoyer les filtres courants dans le body : options contextuelles, une dimension ne s\'auto-restreint pas. Permission BackOffice.Clients.Read. 
     * Facettes de la liste des clients (courtier)
     */
    async getClientListFacets(requestParameters: GetClientListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFacetsResponse> {
        const response = await this.getClientListFacetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liste paginée des clients (personnes ayant au moins un contrat) du périmètre courtier. Permission BackOffice.Clients.Read (403 sinon). searchString cherche sur nom/prénom/ email/téléphone (PP) et désignation/téléphone/SIRET (PM). 
     * Lister les clients (courtier)
     */
    async getClientsRaw(requestParameters: GetClientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetClientListResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getClients().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/clients/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetClientListResponseFromJSON(jsonValue));
    }

    /**
     * Liste paginée des clients (personnes ayant au moins un contrat) du périmètre courtier. Permission BackOffice.Clients.Read (403 sinon). searchString cherche sur nom/prénom/ email/téléphone (PP) et désignation/téléphone/SIRET (PM). 
     * Lister les clients (courtier)
     */
    async getClients(requestParameters: GetClientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetClientListResponse> {
        const response = await this.getClientsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
